import React from 'react';
import styles from './Piece.module.css';
import { PieceType, PlayerColor } from '../../../../../../shared/types/game';

interface PieceProps {
  type: PieceType;
  owner: PlayerColor;
  viewingPlayerColor: PlayerColor;
}

const Piece: React.FC<PieceProps> = ({ type, owner, viewingPlayerColor }) => {
  const imagePath = `/images/pieces/${type}.png`; 

  const needsRotation = (owner === 'gote' && viewingPlayerColor === 'sente') ||
                        (owner === 'sente' && viewingPlayerColor === 'gote');

  return (
    <div className={`${styles.pieceContainer} ${needsRotation ? styles.rotated : ''}`}>
      <img src={imagePath} alt={type} className={styles.pieceImage} />
    </div>
  );
};

export default Piece;